import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh";
import en from "./en";
import store from "@/store";

Vue.use(VueI18n); // 全局注册
export const i18n = new VueI18n({
  locale: store.getters.lang, // 初始化为中文
  messages: {
    zh: zh,
    en: en,
  },
});

// 重新封装方法
export function $t(args) {
  return i18n.tc.call(i18n, args);
}
